"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingsAndReviewsCount = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const link_1 = __importDefault(require("@kyruus/link"));
const messages_1 = __importDefault(require("../../common/util/constants/messages"));
const styles_1 = require("../styles");
exports.RatingsAndReviewsCount = (0, intl_1.injectIntl)(({ handleClickRatingReviewCount, ratingCount, ratingReviewCountHref, reviewCount, shouldHidePageAnchors, intl }) => {
    const ratingReviewCountMessage = intl.formatMessage(messages_1.default.ratingReviewCount, {
        ratingCount,
        reviewCount,
        ratings: ratingCount,
        reviews: reviewCount
    });
    if (shouldHidePageAnchors) {
        return (react_1.default.createElement(styles_1.RatingReviewCountText, null, ratingReviewCountMessage));
    }
    return (react_1.default.createElement(link_1.default, { href: ratingReviewCountHref, onClick: handleClickRatingReviewCount }, ratingReviewCountMessage));
});
//# sourceMappingURL=RatingsAndReviewsCount.js.map